import { useTheme, Box, AppBar, makeStyles, Theme, createStyles, Button, Grid, Hidden } from "@material-ui/core";
import { Quote } from "../../../api/Quote/Quote";
import { colors } from "swyft-react-core";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import { TF } from "../../../components/typography/TF";

const QuoteCartTop = ({ quote, onBack }: Props) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <AppBar className={classes.root} position="static" color="transparent">
      <Grid className={classes.grid} alignItems="center" container>
        <Grid item xs={12} container alignItems="center">
          <Box fontSize="1.5rem" className={classes.button}>
            <Button onClick={onBack} color="secondary">
              {theme.direction === "rtl" ? (
                <KeyboardArrowRight color="primary" />
              ) : (
                <KeyboardArrowLeft color="primary" />
              )}
              <Hidden mdDown>Back</Hidden>
            </Button>
          </Box>
          <Hidden lgUp>
            <Box flexGrow={1} p={1}>
              <TF variant="caption">Total</TF>
              <TF variant="body1" bold format="price">
                {quote.price}
              </TF>
            </Box>
          </Hidden>
        </Grid>
      </Grid>
    </AppBar>
  );
};

export default QuoteCartTop;

interface Props {
  onBack: () => void;
  quote: Quote;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.16)",
      borderBottom: "4px solid " + colors.secondary
    },
    grid: {
      position: "relative"
    },
    button: {
      borderRight: "1px solid " + colors.lightGrey,
      padding: theme.spacing(1),
      paddingRight: theme.spacing(3),
      [theme.breakpoints.down("xs")]: {
        "padding": 0,
        '& [class*="Button-root"]': {
          minWidth: theme.spacing(1)
        }
      }
    }
  })
);
